export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  documentType: null,
  documentNumber: null,
  charge: null,
  duration: null,
  typePermission: null,
  description: null,
  initDate: null,
  initTime: null,
  endDate: null,
  endTime: null,
  remuner: null,
  regional: null,
  applicationDate: new Date(),
  observations: null,
};

export const remunerValidate = ["Remunerado", "No remunerado"];

export const defaultValuesChilds = {
  personId: null,
  name: null,
  birthDate: null,
  creationDate: new Date(),
  dateUpdate: null,
  userCreation: "Developer",
  userUpdate: null,
};
